if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    connectedCallback() {
      if (this.dataset.initialized === 'true') return;
      this.dataset.initialized = 'true';

      this.form = this.querySelector('form');
      this.submitButton = this.querySelector('button[type=submit][name=add], [type=submit][name=add]');
      this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
      this.hideErrors = this.dataset.hideErrors === 'true';
      this.cart = document.querySelector('mini-cart, cart-drawer');

      if (!this.form || !this.submitButton) return;

      const variantInput = this.form.querySelector('input[name="id"]');
      if (variantInput) variantInput.disabled = false;

      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.submitButton.addEventListener('click', () => {
        const input = this.form.querySelector('input[name="id"]');
        if (input) input.disabled = false;
      });

      if (document.querySelector('cart-drawer') && this.submitButton) {
        this.submitButton.setAttribute('aria-haspopup', 'dialog');
      }
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      if (!this.form || !this.submitButton) return;
      if (this.submitButton.disabled || this.submitButton.getAttribute('aria-disabled') === 'true') return;

      const variantInput = this.form.querySelector('input[name="id"]');
      if (!variantInput || !variantInput.value) {
        this.handleErrorMessage('No se pudo identificar el producto. Recarga la página e inténtalo nuevamente.');
        return;
      }
      variantInput.disabled = false;

      this.error = false;
      this.handleErrorMessage();
      this.submitButton.setAttribute('aria-disabled', 'true');
      this.submitButton.classList.add('loading');

      const formData = new FormData(this.form);
      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json'
        },
        body: formData
      };

      if (this.cart && typeof this.cart.getSectionsToRender === 'function') {
        const sections = this.cart.getSectionsToRender().map((section) => section.id).filter(Boolean);
        if (sections.length) formData.append('sections', sections.join(','));
        formData.append('sections_url', window.location.pathname);
        if (typeof this.cart.setActiveElement === 'function') this.cart.setActiveElement(document.activeElement);
      }

      fetch((window.theme && theme.routes && theme.routes.cart_add_url) || '/cart/add.js', config)
        .then(async (response) => {
          const text = await response.text();
          let data;
          try { data = JSON.parse(text); } catch (e) { throw new Error('Respuesta inválida del servidor'); }
          if (!response.ok || data.status) {
            throw new Error(data.description || data.message || 'No pudimos agregar el producto al carrito.');
          }
          return data;
        })
        .then((response) => {
          if (this.cart && typeof this.cart.renderContents === 'function') {
            this.cart.renderContents(response);
          } else if (this.cart && typeof this.cart.open === 'function') {
            this.cart.open();
          } else {
            window.location.href = (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
            return;
          }
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: response } }));
        })
        .catch((error) => {
          this.error = true;
          console.error('Magik Print cart error:', error);
          this.handleErrorMessage(error.message || 'No pudimos agregar el producto. Inténtalo nuevamente.');
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          this.submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      if (this.hideErrors) return;
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
      if (!this.errorMessage) return;
      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
      if (errorMessage) this.errorMessage.textContent = errorMessage;
    }

    toggleSubmitButton(disable = true, text) {
      if (!this.submitButton) return;
      if (disable) {
        this.submitButton.setAttribute('disabled', 'disabled');
        if (text && this.submitButtonText) this.submitButtonText.textContent = text;
      } else {
        this.submitButton.removeAttribute('disabled');
        this.submitButton.removeAttribute('aria-disabled');
        if (this.submitButtonText && window.theme?.variantStrings?.addToCart) {
          this.submitButtonText.textContent = theme.variantStrings.addToCart;
        }
      }
    }

    get variantIdInput() {
      return this.form ? this.form.querySelector('input[name="id"]') : null;
    }
  });
}
